module.exports = __webpack_public_path__ + "img/1.42992d7c.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1332,"height":742,"variants":[{"file":"img/1-480w.69cc2f8df0f7.webp","width":480},{"file":"img/1-960w.42e6dffd57b2.webp","width":960},{"file":"img/1-1332w.614b08f3fd3d.webp","width":1332}]};
}